import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Pagination, Table } from 'antd';
import { selectors } from '../../../../model';
import { uploadingFieldNames } from '../../../../config/uploadingStep';
import { settingStepFields } from '../../../../config/import';
import { declOfNum } from '../../../../../../../../helpers/dspx-utils';
import styles from './PreviewStep.module.scss';

const { selectUploadingStepValue } = selectors;

const importTypeSelector = (state) =>
  selectUploadingStepValue(state, uploadingFieldNames.importType);

const rowKeyFn = (_record, index) => index;

const paginationThreshold = 10;
const pageSizeOptions = ['10', '30', '50', '100'];

const createTotalText = (num) => {
  const text = declOfNum(num, ['записи', 'записей', 'записей']);

  return `${num} ${text}`;
};

const showTotal = (total, range) =>
  `${range[0]}-${range[1]} из ${createTotalText(total)}`;

const getDisplayedRange = (current, pageSize) => {
  const start = (current - 1) * pageSize;
  const end = start + pageSize;
  return [start, end];
};

const createPaginationData = ({
  dataSource,
  pageSize,
  setPageSize,
  currentPage,
  setCurrentPage,
}) => {
  if (dataSource.length <= paginationThreshold) {
    return { displayedItems: dataSource, pagination: false };
  }

  const pagination = {
    pageSize,
    showSizeChanger: true,
    onShowSizeChange: (current, pageSize) => {
      setCurrentPage(current);
      setPageSize(pageSize);
    },
    pageSizeOptions,
    current: currentPage,
    total: dataSource.length,
    onChange: setCurrentPage,
    showTotal,
  };

  const range = getDisplayedRange(currentPage, pageSize);

  return {
    displayedItems: dataSource.slice(...range),
    pagination,
  };
};

const PreviewTable = ({ dataSource }) => {
  const importType = useSelector(importTypeSelector);

  const [pageSize, setPageSize] = useState(Number(pageSizeOptions[0]));
  const [currentPage, setCurrentPage] = useState(1);

  const { displayedItems, pagination } = useMemo(
    () =>
      createPaginationData({
        dataSource,
        pageSize,
        setPageSize,
        currentPage,
        setCurrentPage,
      }),
    [dataSource, pageSize, currentPage]
  );

  const columns = useMemo(
    () =>
      Object.values(settingStepFields[importType]).map(({ label, name }) => ({
        title: label,
        dataIndex: name,
        key: name,
      })),
    [importType]
  );

  return (
    <div>
      <div className={styles.tableWrapper}>
        <Table
          dataSource={displayedItems}
          columns={columns}
          rowKey={rowKeyFn}
          pagination={false}
        />
      </div>
      {Boolean(pagination) && (
        <Pagination
          {...pagination}
          className={styles.pagination}
        />
      )}
    </div>
  );
};

export default PreviewTable;
